import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=619cfe2a&scoped=true"
import script from "./quit.vue?vue&type=script&lang=js"
export * from "./quit.vue?vue&type=script&lang=js"
import style0 from "./quit.vue?vue&type=style&index=0&id=619cfe2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cfe2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619cfe2a')) {
      api.createRecord('619cfe2a', component.options)
    } else {
      api.reload('619cfe2a', component.options)
    }
    module.hot.accept("./quit.vue?vue&type=template&id=619cfe2a&scoped=true", function () {
      api.rerender('619cfe2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffManage/quit.vue"
export default component.exports